export async function GetLeaderboard() {
  const response = await fetch('/api/leaderboard');
  return await response.json();
}
